import { z } from 'zod'

import { TaxReceiptType } from './receipt'
import { CertType, UserType, VerificationStatus } from './user'

export const ZAccount = z.object({
  bankName: z.string(),
  bankAccount: z.string(),
  bankHolder: z.string(),
})

export const ZReceiptInformation = z.object({
  receiptRequested: z.boolean().nullable(), // 영수증 신청 여부
  taxReceiptType: z.nativeEnum(TaxReceiptType).nullable(),
  issuanceNumber: z.string().nullable(), // 현금영수증 발급용 전화번호 또는 카드번호
  corpId: z.string().nullable(), // 사업자 번호
  corpName: z.string().nullable(), // 사업자 명
  corpCeo: z.string().nullable(), // 대표자 이름
  invoiceeEmail: z.string().nullable(), // 이메일 주소,
})

export const ZUserMe = z
  .object({
    email: z.string(),
    name: z.string(),
    profileImageUrl: z.string(),
    phoneNumber: z.string(),
    userType: z.nativeEnum(UserType),
    isCertificated: z.boolean(),
    certType: z.nativeEnum(CertType).nullable(),
    passportImageUrl: z.string().nullable(),
    verificationStatus: z.nativeEnum(VerificationStatus),
    holdReason: z.string().nullable(),
    detailReason: z.string().nullable(),
    hostIntro: z.string(),
    isSuperHost: z.boolean(),
    bankName: z.string(),
    bankAccount: z.string(),
    bankHolder: z.string(),
    emailCertified: z.boolean(),
  })
  .merge(ZReceiptInformation)

export type TAccount = z.infer<typeof ZAccount>
export type TReceiptInformation = z.infer<typeof ZReceiptInformation>

export type TUserMe = z.infer<typeof ZUserMe>
